module.exports = __webpack_public_path__ + "img/hr-brown-fluff-11.72cd5914.png";